var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center p-a-md text-sm"},[_vm._v("蜀ICP备18009933号-1 © "+_vm._s(_vm.title)+" 2019")])}
var staticRenderFns = []

export { render, staticRenderFns }